/**
 * Обрезает строку в центре и добавляет в середине "..."
 * Как работает: "verylongsting" | cut(30) . Обрезает строку если в ней больше 30 символов.
 * По умолчанию стоит 40.
 * cut(100, 'end') - обрезает строку в конце если она длиннее 100 символов
 */
export default function cut(value, symbols = 40, whereCut) {
  try {
    if (value) {
      if (whereCut === 'end') {
        return value.length > symbols ? value.substr(0, symbols) + '...' : value
      } else {
        return value.length > symbols ? value.substr(0, Math.floor(symbols*55/100)) + '...' + value.substr(value.length-Math.floor(symbols*30/100), Math.floor(symbols*30/100)) : value
      }
    }
  } catch (e) {
    console.log(e)
  }
}
